export const themeStyle = {
  primary:"purple",
    cardBackgroundColor: "white",
    cardBackgroundColorBorder:"1px solid #4C02C7",
    cardHeaderAndValuesColor:"black",
    cardValuesHeadingColor:"#4987FF",
   
  };